module.exports = __webpack_public_path__ + "assets/favicons/google-signin-btn.svg";